const Footer = () => {
  return (
    <div className="footer">
            <p className='right-reserved'>© Booom 2024</p>
    </div>
  )
}
export default Footer